'use client';

import AppImage from '@/components/ui/AppImage';
import useScrollReveal from '@/hooks/useScrollReveal';
import { useEffect, useState } from 'react';

export default function AboutHero() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollReveal<HTMLElement>();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section ref={heroRef} className="relative h-[60vh] min-h-[500px] sm:min-h-[550px] md:min-h-[600px] overflow-hidden">
      {/* Hero Image with Parallax */}
      <div
        className="absolute inset-0 z-0"
        style={{ transform: `translateY(${scrollY * 0.3}px)` }}>
        
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_152386b3a-1773097151601.png"
          alt="Brandon Green working on laptop in gritty industrial space with exposed brick and raw authentic energy"
          width={1920}
          height={1080}
          className="w-full h-full object-cover" />
        
        {/* Dark overlay for edge */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 flex items-center z-10">
        <div className={`max-w-3xl transition-all duration-1000 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-block px-3 py-1.5 sm:px-5 sm:py-2 bg-brand-plum text-white font-body text-[10px] sm:text-xs font-bold mb-3 sm:mb-4 uppercase tracking-wider transition-all duration-300 hover:bg-brand-teal">
            DALLAS-BASED • BOUTIQUE BY DESIGN
          </div>
          <h1 className="font-headline text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-3 sm:mb-4 text-white font-bold leading-tight">
            About
          </h1>
          <p className="font-body text-sm sm:text-base md:text-lg text-white leading-relaxed max-w-3xl">
            This isn't a high-volume agency churning out templated solutions. This is a selective growth partner for founders who've been overlooked by everyone else and deserve better.
          </p>
        </div>
      </div>
    </section>);

}